  window.addEventListener("load",function(){
    $(".js-show-bigBigImg").click(function(){
      $(".popshow_bigImage").attr("src",$(this).data("bigimg")).show()
      $(".popshow_bigImgBox").fadeIn()
      $("body").addClass("popshow")
      $("html").addClass("popshow")
    })
    $(".popshow_bigImgBox").click(function(){
      $(".popshow_bigImage").attr("src","").hide()
      $(".popshow_bigImg_iframe").html("").hide()
      $(".popshow_bigImgBox").fadeOut()
      $("body").removeClass("popshow")
      $("html").removeClass("popshow")
    })
    $(".js-tab-item").click(function() {
      if (!$(this).hasClass("active")) {
        $(this).siblings().removeClass("active")
        $(this).addClass("active")
        let index = $(this).index()
        $(this).parent().siblings(".tab-contents").find(".tab-content").hide()
        $(this).parent().siblings(".tab-contents").find(".tab-content").eq(index).show()
      }
    })
    $(".js_show_custom").click(function() {
      let id = $(this).data("htmlid")
      $(id).find(".custom_html_content").removeClass("d-none")
    })
    $(".gardener-section2-container1-item-more").click(function() {
      if ($(this).parents(".gardener-section2-container1-item-content1").siblings(".gardener-section2-container1-item-content1-pop").css("display") == "none") {
       $(".gardener-section2-container1-item-content1-pop").fadeOut()
       $(this).parents(".gardener-section2-container1-item-content1").siblings(".gardener-section2-container1-item-content1-pop").fadeIn()
      }else{
       $(this).parents(".gardener-section2-container1-item-content1").siblings(".gardener-section2-container1-item-content1-pop").fadeOut()
      }
    })
    $(".gardener-section2-container1-item-content1-pop-close").click(function() {
      $(".gardener-section2-container1-item-content1-pop").fadeOut()
    })
    $(".js-open-iframe-pop").click(function() {
      if ($(this).data("iframe")) {
        
         let iframe_content =`<iframe width="560" height="315" src="${$(this).data("iframe")}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`
          $(".popshow_bigImg_iframe").html(iframe_content).show()
          $(".popshow_bigImgBox").fadeIn()
          $("body").addClass("popshow")
          $("html").addClass("popshow")
      }
    })
    $(".js_change_inventory").change(function(){
      let inventory = $(this).data("inventory")
      let allinventory = $(this).data("allinventory")
      let sold = Math.floor((allinventory - inventory) * 100 / allinventory) + "%"
      $(this).parents(".landing-product-item").find(".real_time_inventory_bg").css("--sold",sold)
      $(this).parents(".landing-product-item").find(".real_time_inventory_sold span").html(sold)
    })
    $(".contact-tab-item").click(function(){
      if(!$(this).hasClass("active")){
        let index = $(this).index()
        $(this).siblings().removeClass("active")
        $(this).addClass("active")
        $(this).parent().parent().find(".contact-tab-contents").find(".contact-tab-content").removeClass("active")
        $(this).parent().parent().find(".contact-tab-contents").find(".contact-tab-content").eq(index).addClass("active")
      }
    })
    $(".js-open-giveaway-pop").click(function(){
      $(".giveaway-pop").fadeIn()
           $("body").addClass("popshow")
      $("html").addClass("popshow")
    })
    $(".giveaway-pop").click(function() {
        $(".giveaway-pop").fadeOut()
        $("body").removeClass("popshow")
        $("html").removeClass("popshow")
    })
    $(".giveaway-pop-box").click(function(e) {
        e.stopPropagation()
    })
    $(".close-giveaway-pop").click(function() {
         $(".giveaway-pop").fadeOut()
         $("body").removeClass("popshow")
         $("html").removeClass("popshow")
    })
  })
  function getEveryEnd(isDST){
    let localTime = new Date().getTime()
    var utc = localTime + new Date().getTimezoneOffset()*60000
    if(isDST)
       var pdtLocalTime = new Date(utc - (3600000 * 7))
    else{
       var pdtLocalTime = new Date(utc - (3600000 * 8))
    }
    var timeEnd = new Date(new Date(new Date(pdtLocalTime).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000)
    var timeStart = new Date(pdtLocalTime).getTime()
    var differH = Math.floor((timeEnd - timeStart) / 1000 / 60 / 60)
    var differM = Math.floor((timeEnd - timeStart) / (1000 * 60) % 60 )
    var differS = Math.floor((timeEnd - timeStart) / 1000 % 60)
    differH = differH >= 10 ? differH : "0" + differH
    differM = differM >= 10 ? differM : "0" + differM
    differS = differS >= 10 ? differS : "0" + differS
    let res = differH + ":" + differM +":"+differS
    return res
  }
function getOffer_new(t) {
  let q1 = 1
  if($(t).attr("data-q0")){
    q1 = $(t).attr("data-q0")
  }
  let items = [
      {
       id: $(t).attr("data-id0"),
       quantity: q1
      },
       {
       id: $(t).attr("data-id1"),
       quantity: 1
      }
    ]
    $.ajax({
       type: "POST",
        url:"/cart/add.js",
        data:{items},
      dataType:"json",
        success:function(res){
          window.location.href ="/checkout"
        }
    })
}